import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateExerciseSingle = {
  exerciseSingle: { data: null, loading: false, error: null },
};

export const exerciseSingle = createAsyncThunk('user/exerciseSingle', async ({ id }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/exercise/${id}`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerExerciseSingle = {
  [exerciseSingle.pending]: (state) => {
    state.exerciseSingle.loading = true;
  },
  [exerciseSingle.fulfilled]: (state, action) => {
    state.exerciseSingle.loading = false;
    state.exerciseSingle.data = action.payload;
    state.exerciseSingle.error = null;
  },
  [exerciseSingle.rejected]: (state, action) => {
    state.exerciseSingle.data = null;
    state.exerciseSingle.loading = false;
    state.exerciseSingle.error = action.payload;
  },
};
